/*global _ */
import spaces from '../../../../../../spaces.json'
export {spaces}
const ad = window.addiesaas || (window.addiesaas = {})
const adConfig = ad.config || {}
export const env = adConfig.env
export const routes = _.keyBy(ad['routes'] || [], 'name')

import {root as rootSetting} from './settings'
export const debug = rootSetting('debug',  rootSetting('global.debug'))
export const debugLog = (...args) => {
  if (debug) {
     // eslint-disable-next-line no-console
    console.log(...args)
  }
}
export const config = Object.assign({}, {
  debug,
  env,
  routes,
  RE: ad,
  CONFIG: adConfig,
  spaces
})

Vue.prototype.$$debug = debug
Vue.prototype.$$env = env
Vue.prototype.$$debugLog = debugLog

const isDevTools = debug === true || (!_.isBoolean(debug) && /local|development/i.test(env))
if (isDevTools) {
  // eslint-disable-next-line no-console
  debugLog('Enable Vue Dev Tools')
  Vue.config.devtools = true
}

export default config

